module.exports = __webpack_public_path__ + "static/media/organization-office-building-profile.37f79d33.svg";